import React from 'react';
import { Snackbar, Alert, Slide } from '@mui/material';
import {
  WifiOff as OfflineIcon,
  Wifi as OnlineIcon
} from '@mui/icons-material';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

/**
 * Slide transition from top
 */
const SlideTransition = (props) => {
  return <Slide {...props} direction="down" />;
};

/**
 * OfflineIndicator Component
 * Shows a banner when the app goes offline or comes back online
 */
const OfflineIndicator = () => {
  const { isOnline, wasOffline } = useOnlineStatus();

  return (
    <>
      {/* Offline Banner */}
      <Snackbar
        open={!isOnline}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={SlideTransition}
        sx={{ top: { xs: 56, sm: 64 } }}
      >
        <Alert
          severity="warning"
          icon={<OfflineIcon />}
          sx={{
            width: '100%',
            maxWidth: 600
          }}
        >
          You're offline - some features may be limited
        </Alert>
      </Snackbar>

      {/* Back Online Banner */}
      <Snackbar
        open={isOnline && wasOffline}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={SlideTransition}
        sx={{ top: { xs: 56, sm: 64 } }}
      >
        <Alert
          severity="success"
          icon={<OnlineIcon />}
          sx={{
            width: '100%',
            maxWidth: 600
          }}
        >
          Back online - syncing data...
        </Alert>
      </Snackbar>
    </>
  );
};

export default OfflineIndicator;
